import { priceDisplayModeToggleRouting } from '@honeycomb/routing';
import { RadioToggle, RadioToggleButton, useForkRef } from '@honeycomb/ui-core';
import React, { useEffect } from 'react';
import { PriceDisplayMode, useGlobalContext, usePriceDisplayMode, PRICE_DISPLAY_MODE_CHANGE_EVENT, } from '@honeycomb/data';
import { useDebounce } from '../../utils/useDebounce';
export const PriceDisplayModeToggle = React.forwardRef(function PriceDisplayModeToggle(props, ref) {
    const { resourceStrings: { PRICEMODETOGGLE_TOTAL, PRICEMODETOGGLE_PERPERSON }, } = useGlobalContext();
    const radioToggleRef = React.useRef(null);
    const handleRef = useForkRef(ref, radioToggleRef);
    const [currentPriceMode, setCurrentPriceMode] = usePriceDisplayMode();
    const [value, setValue] = React.useState(currentPriceMode);
    const handlePriceToggle = useDebounce((newMode) => {
        setCurrentPriceMode(newMode);
        priceDisplayModeToggleRouting(newMode);
    }, 300);
    const handleChangeValue = React.useCallback((newValue) => {
        // Update the local state to re-render the toggle
        setValue(newValue);
        // Call the debounced update
        handlePriceToggle(newValue);
    }, [handlePriceToggle]);
    useEffect(() => {
        var _a;
        (_a = radioToggleRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
    }, [value]);
    // Sync local value with external changes via custom event
    React.useEffect(() => {
        const handleCustomEvent = (e) => {
            const customEvent = e;
            setValue(customEvent.detail);
        };
        window.addEventListener(PRICE_DISPLAY_MODE_CHANGE_EVENT, handleCustomEvent);
        return () => {
            window.removeEventListener(PRICE_DISPLAY_MODE_CHANGE_EVENT, handleCustomEvent);
        };
    }, []);
    return (React.createElement(RadioToggle, Object.assign({ ref: handleRef, value: value, onChangeValue: handleChangeValue }, props),
        React.createElement(RadioToggleButton, { value: PriceDisplayMode.TotalPrice, "data-id": "price-toggle-total" }, PRICEMODETOGGLE_TOTAL),
        React.createElement(RadioToggleButton, { value: PriceDisplayMode.PerPersonPrice, "data-id": "price-toggle-per-person" }, PRICEMODETOGGLE_PERPERSON)));
});
